import { GET_WARNINGS, GET_WARNINGS_SUCCESS, GET_WARNINGS_ERROR} from './actionTypes';

const initialState = {
    errorGetWarning: "",
    loadingGetWarning: false,
    warnings: null,
    successGetWarning: ""
}

const getWarnings = (state = initialState, action) => {
    switch (action.type) {
        case GET_WARNINGS:
            state = {
                ...state,
                loadingGetWarning: true
            }
            break;
        case GET_WARNINGS_SUCCESS:
            state = {
                ...state,
                loadingGetWarning: false,
                warnings: action.payload.warnings, 
                successGetWarning: action.payload.message
            }
            break;
        case GET_WARNINGS_ERROR:
            state = { ...state, errorGetWarning: action.payload, loadingGetWarning: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getWarnings;